import { Keys, Scene, Vector } from "excalibur";
import HoneyStand from "../actors/honeyStand";
import { gameState, inventoryState, playerState } from "../state/stateManager";
import { goToScene } from "../main";
import {
  checkFirstSale,
  createGainedItem,
  getBrandAwarenessConversion,
  sendAlert,
} from "../utils";
import { Resources } from "../Resources";

import { Player } from "../player";
import Katie from "../actors/characters/katie";
import InventoryHUD from "../ui/inventory";
import jar from "./../../res/jar.png";
export default class MccartysCommerce extends Scene {
  constructor() {
    super();

    this.active = 0;
    this.sellHoney = false;
    this.selected = false;
    this.cashout = false;
    const player = new Player(17 * 16, 16 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 4;
    this.katie = new Katie({ x: 17 * 16, y: 13 * 16 });
    this.katie.z = 4;
    this.katie.cutScene = true;
    this.player.cutScene = true;
    this.shelfSpace = 12;
    this.offering = 5;
  }
  onActivate(engine) {
    this.inventory = inventoryState.getInventory();
    this.coins = gameState.getCoins();
    Resources.McCartysMap.addToScene(this);
    this.getShelfSpace();
    this.add(this.player);
    this.add(this.katie);
    this.jarsToAdd = 0;

    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.style.display = "flex";
    this.menuContainer.classList.add("commerce");
    this.menu = document.getElementById("feed-menu");
    console.log("menu: ", this.menu);
    this.menu.style.display = "block";
    this.inventoryHUD = new InventoryHUD("mccartysCommerce");
    if (this.inventory.filledJars >= this.shelfSpace) {
      this.jarsToAdd = this.shelfSpace;
    } else {
      this.jarsToAdd = this.inventory.filledJars;
    }
    this.drawMenu();
  }
  drawMenu() {
    console.log("inside drawmenu: ", this.active);
    if (this.active == 0) {
      this.menu.innerHTML = `<h1>McCarty's</h1>
       
        <ul>
            <li id="list0"><span id="selector">></span>Sell Honey</li>
            <li id="list1">Buy Items</li>
          
          </ul>
       
        `;
    } else if (this.active == 1) {
      this.menu.innerHTML = `<h1>McCarty's</h1>
        
        <ul>
            <li id="list0">Sell Honey</li>
            <li id="list1"><span id="selector">></span>Buy Items</li>
          
          </ul>
       
        `;
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      Resources.Click.play();
      if (this.sellHoney) {
        if (this.jarsToAdd + 1 <= this.inventory.filledJars) {
          if (this.jarsToAdd + 1 <= this.shelfSpace) {
            this.jarsToAdd++;
            this.openSellHoneyMenu();
          } else {
            Resources.Error.play();
            sendAlert("Limited Shelf Space");
          }
        } else {
          Resources.Error.play();
          sendAlert("Not Enough Jars");
        }
      } else {
        if (this.active == 0) {
          this.active = 1;
        } else {
          this.active = 0;
        }
        this.drawMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play();
      if (this.sellHoney) {
        this.jarsToAdd = this.jarsToAdd - 1;
        if (this.jarsToAdd < 0) {
          Resources.Error.play();
          this.jarsToAdd = 0;
        }
        this.openSellHoneyMenu();
      } else {
        console.log("active : ", this.active);
        if (this.active == 0) {
          this.active = 1;
        } else {
          this.active = 0;
        }
        this.drawMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      if (this.active == 0) {
        //restock
        this.selected = true;
        this.sellHoney = true;
        Resources.Inventory.play();
        this.openSellHoneyMenu();
      } else if (this.active == 1) {
        //cash out
        this.selected = true;
        this.buyItems = true;
        Resources.Inventory.play();
        this.openBuyItemsMenu();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      if (this.selected) {
        this.drawMenu();
        this.sellHoney = false;
        this.buyItems = false;
        this.selected = false;
      } else {
        goToScene("mccartys");
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Space)) {
      console.log(
        "space: selling: ",
        this.sellHoney,
        " cashOut: ",
        this.buyItems
      );
      if (this.sellHoney) {
        if (this.jarsToAdd <= this.shelfSpace) {
          this.inventory.filledJars =
            this.inventory.filledJars - this.jarsToAdd;

          //set last sold on farmers market state
          //get cash
          let con = playerState.getContent();
          con.mccartys.lastSold = new Date().getTime();
          playerState.setContent(con);
          let coins = gameState.getCoins();
          coins = coins + parseInt(this.jarsToAdd * this.offering);
          gameState.setCoins(coins);
          Resources.Coins.play();
          checkFirstSale();
          inventoryState.setInventory(this.inventory);
          this.inventoryHUD.display();
          createGainedItem(`$${parseInt(this.jarsToAdd * this.offering)}`);
          this.getShelfSpace();
          this.selected = false;
          this.active = 0;
          this.drawMenu();
        } else {
          Resources.Error.play();
          sendAlert("Limited Shelf Space");
        }
      } else if (this.buyItems) {
      }
    }
  }
  onDeactivate() {
    this.menuContainer.style.display = "none";
    this.menu.style.display = "none";
    this.menuContainer.classList.remove("commerce");
    this.inventoryHUD.destroy();
  }
  openBuyItemsMenu() {
    this.menu.innerHTML = `<h1>McCartys</h1>
   
    <h3>No Items To Buy</h3><p>X> BACK</p>
   
    `;
  }
  openSellHoneyMenu() {
    this.menu.innerHTML = `<h1>Farmers Market</h1>
    
    <h3>Shelf Space: ${this.shelfSpace}</h3>
    <h3>Offering $${this.offering} per jar</h3>
    <h3>Jars To Sell</h3><h3><img class="productImage"src="${jar}"/><span class="iterate">${this.jarsToAdd}</span></h3><p>Use Arrow Keys To Iterate</p><p>Hit Space To Sell</p><p>X> BACK</p>
   
    `;
  }
  getRelationshipConversion(availableJars) {
    let content = playerState.getContent();
    let relationship = content.katie.relationship;
    if (relationship < 10) {
      return availableJars * 0.5;
    } else if (relationship >= 10 && relationship < 20) {
      //mid}
      return availableJars * 0.75;
    } else if (relationship > 20) {
      //full
      return availableJars;
    }
  }
  getTimePassed(unTranslatedTime) {
    let speed = gameState.getGameSpeed();
    let transTime = speed * unTranslatedTime;
    let hours = transTime / 3600000;
    console.log("time passed: ", hours, " hours");
    let totalShelfSpace = 0;
    let totalTime = 72;
    if (hours >= 72) {
      //give full availability
      totalShelfSpace = this.getRelationshipConversion(10);
      totalShelfSpace = getBrandAwarenessConversion(totalShelfSpace);
    } else {
      //fraction availability by time
      let frac = hours / 72;

      totalShelfSpace = getBrandAwarenessConversion(totalShelfSpace);
      totalShelfSpace = this.getRelationshipConversion(10 * frac);
    }
    return totalShelfSpace;
  }
  getShelfSpace() {
    this.content = playerState.getContent();

    if (this.content.mccartys.lastSold == null) {
      //full jar availablility
      this.shelfSpace = 40;
    } else {
      //base jar availability on last sold and relationship with katie and random
      this.shelfSpace = this.getTimePassed(
        new Date().getTime() - this.content.mccartys.lastSold
      );
    }
  }
}
